<template>
  <div class="block">
    <img :src="avansQrImg" class="img1" />
    <div class="start">
      <div class="block-header">
        {{ $t("page.activation.header", { msgr: "Whatsapp" }) }}
      </div>
      <ul>
        <li>{{ $t("page.activation.text1", { msgr: "Whatsapp" }) }}</li>
        <li>{{ $t("page.activation.text2", { msgr: "Whatsapp" }) }}</li>
        <li>{{ $t("page.activation.text3") }}</li>
      </ul>
      <ButtonLoading class="ec_button" :loading="loading" @click="generateQR">
        {{ $t("page.activation.button") }}
      </ButtonLoading>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import ButtonLoading from "@/components/Recurring/ButtonLoading";
import { useStore } from "vuex";
import useActivationWhatsapp from "./api/useActivationWhatsapp";
import avansQrImg from "@/assets/avans-activation/avans-qr.png";

const store = useStore();

const { initiateActivationWhatsapp, activationStatus } =
  useActivationWhatsapp();

const loading = ref(false);

const props = defineProps({
  number: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["nextStage"]);
const generateQR = async () => {
  loading.value = true;
  await initiateActivationWhatsapp(props.number);
  emits("nextStage", {
    value: activationStatus.value,
  });
  loading.value = false;
};
</script>

<style lang="scss" scoped>
.block {
  padding: 23px 48px;

  width: 100%;
  border-radius: 11px;
  background: var(--block-color);
  display: flex;
  align-items: center;
  gap: 52px;

  box-sizing: border-box;

  .img1 {
    width: 200px;
    margin: 0;
  }

  .start {
    padding: 0 20px 0 0;
    font-family: "Gilroy";
    font-weight: 700;
    font-size: 24px;
    color: var(--text-second-color);
    text-transform: none;
    line-height: 170%;

    :deep(.txt) {
      font-weight: 700;
      font-size: 24px;
      color: var(--text-second-color);
      text-transform: none;
      line-height: 170%;
      margin-bottom: 25px;
    }

    .block-header {
      margin-bottom: 25px;

      @media screen and (max-width: var(--tablet-max-size)) {
        font-size: 20px;
        line-height: 150%;
      }
    }

    ul {
      list-style: none;

      li {
        position: relative;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: var(--text-third-color);
        margin: 10px 0;
        padding-left: 25px;

        &::before {
          content: url("@/assets/intlTel/check.svg");
          position: absolute;
          left: 0;
          top: 10px;
          transform: translateY(-50%);
          width: 10px;
          height: 10px;
        }
      }
    }

    .ec_button {
      margin-top: 20px;
      width: 230px;
    }
  }

  @media screen and (max-width: 680px) {
    .block-header {
      font-size: 14px;
      line-height: 150%;
    }

    .start {
      padding: 0;

      ul li {
        font-size: 12px;
        line-height: 150%;

        &::before {
          top: 5px;
        }
      }

      .ec_button {
        width: 100%;
      }
    }

    .img1 {
      width: 220px;
      margin: 0;
    }
  }
}
</style>
